module.exports = __webpack_public_path__ + "static/img/pic_huodong@2x.22f15556.png";